export default __webpack_public_path__ + "static/media/euro.383f8025.svg";